/* istanbul ignore file */
import { useEmployeeService } from 'domain/shared/employee';
import { Show } from 'framework/show';
import React from 'react';
import { useEmployeeId } from 'domain/people/employee/employeeIdentityRouting';

const ShowEmployee = ({ children = null }: { children?: React.ReactNode }) => {
  const { getById } = useEmployeeService();
  const currentAlias = useEmployeeId()!;

  return <Show getDataMethod={() => getById(currentAlias)}>{children}</Show>;
};

export default ShowEmployee;
